import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './shared/locales/en.json';
import ru from './shared/locales/ru.json';
import cn from './shared/locales/cn.json';
import { LanguageTypes } from '@uni-space/uni-components';

const resources = {
  [LanguageTypes.en]: {
    translation: en,
  },
  [LanguageTypes.cn]: {
    translation: cn,
  },
  [LanguageTypes.ru]: {
    translation: ru,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language') ?? 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
